import { render, staticRenderFns } from "./TagTitle.vue?vue&type=template&id=d33705b6&scoped=true&"
import script from "./TagTitle.vue?vue&type=script&lang=js&"
export * from "./TagTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33705b6",
  null
  
)

export default component.exports